import React from "react";
import { Link } from "react-router-dom";
import { Stethoscope, ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, lastUpdate, children }) {
  return (
    <div className="min-h-screen bg-[hsl(var(--bg-base))]">
      <header className="px-6 md:px-10 h-16 flex items-center justify-between border-b border-[hsl(var(--border-divider))] bg-white sticky top-0 z-20">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-lg bg-[hsl(var(--brand))] text-white flex items-center justify-center">
            <Stethoscope className="w-5 h-5" />
          </div>
          <div className="text-[15px] font-semibold" style={{fontFamily:"'Outfit',sans-serif"}}>Iatrós</div>
        </Link>
        <Link to="/" className="text-sm text-[hsl(var(--text-tertiary))] hover:text-[hsl(var(--text-primary))] inline-flex items-center gap-1">
          <ArrowLeft className="w-4 h-4" /> Início
        </Link>
      </header>
      <article className="max-w-3xl mx-auto px-6 md:px-10 py-12">
        <div className="ds-overline">Documento legal</div>
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight mt-2" style={{fontFamily:"'Outfit',sans-serif"}}>{title}</h1>
        {lastUpdate && <p className="text-sm text-[hsl(var(--text-tertiary))] mt-2">Última atualização: {lastUpdate}</p>}
        <div className="ds-divider my-8" />
        <div className="legal-content text-[hsl(var(--text-primary))] space-y-6 leading-relaxed">
          {children}
        </div>
        <div className="mt-12 flex gap-4 text-sm">
          <Link to="/legal/termos" className="ds-link">Termos de Uso</Link>
          <Link to="/legal/privacidade" className="ds-link">Política de Privacidade</Link>
        </div>
      </article>
    </div>
  );
}
